/* eslint react/prop-types: 0 */
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { VehicleConstants } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/Summary/components/VehicleSpecs/VehicleSpecs.scss';

const VehicleSpecs = ({
    Cityfuel,
    Highwayfuel,
    imageServer,
    selectedDrivePowerTrain,
    selectedOptionsPackageExteriorColour,
    selectedOptionsPackageInteriorColour,
    selectedCabSize,
    selectedBoxSize,
    vehicleConditionType,
    odometer,
}) => {
    const exteriorColourImageServerDomain =
        imageServer && imageServer.imageServerDomain + imageServer.imageExteriorColorsRelative;

    const interiorColourImageServerDomain =
        imageServer && imageServer.imageServerDomain + imageServer.imageInteriorColorsRelative;

    return (
        !!selectedDrivePowerTrain && (
            <div className="car-specs">
                <h2 className="specs-title sr-subtitle-2">{LocaleService.t('summarySection.specs_title')}</h2>
                <div className="specs-bloc">
                    <icon className="icon-Front-Wheel-Drive" />
                    <div className="specs-bloc--content">{selectedDrivePowerTrain.driveTrain.longDescription}</div>
                </div>
                <div className="specs-bloc">
                    <icon className="icon-engine" />
                    <div className="specs-bloc--content">
                        {LocaleService.t(selectedDrivePowerTrain.engine.isTurbo ? 'engine.sizeTurbo' : 'engine.size', {
                            displacement: selectedDrivePowerTrain.engine.displacement,
                            cylinders: selectedDrivePowerTrain.engine.cylinders,
                        })}
                        {selectedDrivePowerTrain.engine.hp > 0 &&
                            selectedDrivePowerTrain.engine.torque > 0 && (
                                <span>
                                    {LocaleService.t('engine.power', {
                                        hp: selectedDrivePowerTrain.engine.hp,
                                        torque: selectedDrivePowerTrain.engine.torque,
                                    })}
                                </span>
                            )}
                    </div>
                </div>
                <div className="specs-bloc">
                    <icon className="icon-transmission" />
                    <div className="specs-bloc--content">
                        {LocaleService.t(
                            selectedDrivePowerTrain.transmission.isCVT
                                ? 'transmission.cvt'
                                : 'transmission.typesSpeeds',
                            {
                                type: selectedDrivePowerTrain.transmission.description,
                                speeds: selectedDrivePowerTrain.transmission.speeds,
                            }
                        )}
                        <span className="fuel-consumption">
                            {LocaleService.t('summarySection.fuelConsumption', {
                                CityFuelConsumption: Cityfuel || LocaleService.t('fuel.N/A'),
                                HighwayFuelConsumption: Highwayfuel || LocaleService.t('fuel.N/A'),
                            })}
                        </span>
                    </div>
                </div>
                {selectedCabSize &&
                    selectedBoxSize && (
                        <div className="specs-bloc">
                            <icon className="icon-truck" />
                            <div className="specs-bloc--content">
                                {LocaleService.t('summarySection.CAB_AND_BOX_SIZES', {
                                    cabSize: LocaleService.capitalizeTitle(selectedCabSize.description),
                                    boxSize: selectedBoxSize.description,
                                })}
                            </div>
                        </div>
                    )}
                {selectedOptionsPackageExteriorColour.colourTile &&
                    exteriorColourImageServerDomain && (
                        <div className="specs-bloc">
                            <img
                                alt={selectedOptionsPackageExteriorColour.colourTile}
                                src={exteriorColourImageServerDomain + selectedOptionsPackageExteriorColour.colourTile}
                                className="specs-bloc--color"
                            />
                            <div className="specs-bloc--content">
                                {LocaleService.t('summarySection.exterior_color_label')}
                                <span>{selectedOptionsPackageExteriorColour.colourDescription}</span>
                            </div>
                        </div>
                    )}
                {selectedOptionsPackageInteriorColour.colourTile &&
                    interiorColourImageServerDomain && (
                        <div className="specs-bloc">
                            <img
                                alt={selectedOptionsPackageInteriorColour.colourTile}
                                src={interiorColourImageServerDomain + selectedOptionsPackageInteriorColour.colourTile}
                                className="specs-bloc--color"
                            />
                            <div className="specs-bloc--content">
                                {LocaleService.t('summarySection.interior_color_label')}
                                <span>
                                    {`${selectedOptionsPackageInteriorColour.fabricDescription} - ${
                                        selectedOptionsPackageInteriorColour.colourDescription
                                    }`}
                                </span>
                            </div>
                        </div>
                    )}
                {vehicleConditionType &&
                    vehicleConditionType === VehicleConstants.CONDITIONS.DEMO && (
                        <div className="specs-bloc">
                            <icon className="icon-odometer" />
                            <div className="specs-bloc--content">
                                {LocaleService.t('summarySection.odometer')}
                                <span>{odometer} km</span>
                            </div>
                        </div>
                    )}
            </div>
        )
    );
};

VehicleSpecs.defaultProps = {
    selectedDrivePowerTrain: false,
};

VehicleSpecs.propTypes = {
    Cityfuel: PropTypes.number.isRequired,
    Highwayfuel: PropTypes.number.isRequired,
    imageServer: PropTypes.shape({
        imageServerDomain: PropTypes.string.isRequired,
        imageServerFullSize: PropTypes.string.isRequired,
    }),
    selectedDrivePowerTrain: PropTypes.shape(), // <-- BAD !! TODO: #complete
    selectedOptionsPackageExteriorColour: PropTypes.shape({
        colourDescription: PropTypes.string.isRequired,
        colourTile: PropTypes.string.isRequired,
    }),
    selectedOptionsPackageInteriorColour: PropTypes.shape({
        colourDescription: PropTypes.string.isRequired,
        colourTile: PropTypes.string.isRequired,
    }),
};

VehicleSpecs.displayName = 'VehicleSpecs';

export default VehicleSpecs;
